import { __decorate } from "tslib";
import { Component, Prop } from "../../../vue";
import { has } from "lodash-es";
import SchemaBaseView from "./SchemaBaseView";
const ids = ['id', 'type', 'title', 'desc'];
let SchemaEditView = class SchemaEditView extends SchemaBaseView {
  constructor() {
    super(...arguments);
    this.mode = 'edit';
    this.formData = {};
  }
  get schema() {
    return this.formData;
  }
  get isHasId() {
    return typeof this.schema.id === 'string';
  }
  get isItems() {
    return this.options.isItems;
  }
  get isShowItemType() {
    return !this.options.schema.items;
  }
  created() {
    const {
      schema
    } = this.options;
    ids.forEach(id => {
      if (schema[id]) {
        this.$set(this.formData, id, schema[id]);
      }
    });
  }
  async onSave() {
    const isOk = await this.validateForm();
    if (!isOk) return;
    const {
      schema
    } = this.options;
    const {
      formData
    } = this;
    ids.forEach(id => {
      if (has(formData, id)) {
        this.$set(schema, id, formData[id]);
      }
    });
    if (schema.type === 'array' && !this.options.schema.items) {
      // 如果本来有items就不需要加了
      this.$set(schema, 'items', {
        type: this.itemsType
      });
    }
    // 删除无用字段了
    if (schema.fields && schema.type !== 'object') {
      this.$delete(schema, 'fields');
    }
    if (schema.items && schema.type !== 'array') {
      this.$delete(schema, 'items');
    }
    this.$emit('msg', {});
  }
  render() {
    return this.renderForm();
  }
};
__decorate([Prop()], SchemaEditView.prototype, "options", void 0);
SchemaEditView = __decorate([Component({
  name: 'SchemaEditView'
})], SchemaEditView);
export default SchemaEditView;
//# sourceMappingURL=SchemaEditView.js.map
